import React from "react";

import puzzleIcon from "../../images/game-puzzle-icon.png";
import arcadeIcon from "../../images/game-arcade-icon.png";

import { GameLink } from "./style";

export default function GamesLinks({size}) {
  return (
    <div>
      <GameLink
        href="https://storage.googleapis.com/manitoba-etape-auto.appspot.com/apps/jewel-match/index.html"
        size={size}
        src={puzzleIcon}
        width="284"
        height="284"
        title="Jeu Puzzle"
      />
      <GameLink
        href="https://storage.googleapis.com/manitoba-etape-auto.appspot.com/apps/cars-movements/index.html"
        size={size}
        src={arcadeIcon}
        width="284"
        height="284"
        title="Jeu Arcade"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/GamesLinks/index.js